export default "__VITE_ASSET__c540579f__"